export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13521.2cdc9e9d.jpg";